import * as React from "react"
import {
  DirectionFromOrigin,
  InsightSubjectType,
  InsightVisibility,
  type ListInsightsQueryVariables,
} from "@digits-graphql/frontend/graphql-bearer"
import { useAnalysisCategoryTypes } from "src/frontend/components/OS/Applications/Analysis/AnalysisCategoryTypesContext"
import { useViewVersion } from "src/frontend/components/Shared/Contexts/useViewVersion"
import { InsightsCarousel } from "src/shared/components/Insights/InsightsCarousel"
import { useListInsights } from "src/shared/components/Insights/useListInsights"
import useIntervalOrigin from "src/shared/hooks/useIntervalOrigin"

export const AnalysisInsightsCarousel: React.FC = () => {
  const origin = useIntervalOrigin()
  const viewKey = useViewVersion()
  const categoryTypes = useAnalysisCategoryTypes()

  const variables: ListInsightsQueryVariables = React.useMemo(
    () => ({
      filter: {
        viewKey,
        categoryTypes: categoryTypes,
        subjectTypes: [
          InsightSubjectType.Category,
          InsightSubjectType.Party,
          InsightSubjectType.LegalEntity,
        ],
        insightVisibility: InsightVisibility.FullVisibility,
      },
      ...origin,
      intervalCount: 1,
      paginationDirection: DirectionFromOrigin.Past,
      paginationLimit: 6,
      paginationOffset: 0,
    }),
    [categoryTypes, origin, viewKey]
  )

  const { data, loading } = useListInsights(variables)
  const insights = data?.listInsights[0]?.insights
  const entities = data?.listInsights[0]?.entities

  return (
    <InsightsCarousel origin={origin} insights={insights} entities={entities} loading={loading} />
  )
}
